// frontend/admin-portal/src/services/productService.js
import api from './axiosConfig';

export const productService = {
    list: async (params = {}) => {
        const { data } = await api.get('/products', { params });
        return data.data;
    },
    get: async (idOrSlug) => {
        const { data } = await api.get(`/products/${idOrSlug}`);
        return data.data.product;
    },
    stats: async () => {
        const { data } = await api.get('/products/stats');
        return data.data;
    },
    create: async (payload) => {
        const { data } = await api.post('/products', payload);
        return data.data.product;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/products/${id}`, payload);
        return data.data.product;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/products/${id}`);
        return data;
    },
    toggleActive: async (id) => {
        const { data } = await api.patch(`/products/${id}/toggle`);
        return data.data.product;
    },
    adjustStock: async (id, payload) => {
        const { data } = await api.patch(`/products/${id}/stock`, payload);
        return data.data;
    },

    // ---- Import ----
    downloadTemplate: async () => {
        const res = await api.get('/products/import/template', { responseType: 'blob' });
        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'fiberhome-products-template.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },

    importPreview: async (file) => {
        const form = new FormData();
        form.append('file', file);
        const { data } = await api.post('/products/import/preview', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
        });
        return data.data;   // { summary, totalRows, previewRows, truncated }
    },

    importConfirm: async (rows) => {
        const { data } = await api.post('/products/import/confirm', { rows }, {
            timeout: 120000,
        });
        return data.data.summary;
    },
    // ---- Export ----
    listExportColumns: async () => {
        const { data } = await api.get('/products/export/columns');
        return data.data.columns;
    },

    bulkDelete: async (ids) => {
        const { data } = await api.post('/products/bulk-delete', { ids });
        return data.data;   // { deleted, failed, items }
    },

    exportProducts: async (params = {}) => {
        const res = await api.get('/products/export', {
            params,
            responseType: 'blob',
            timeout: 120000,
        });

        // Extract filename from headers if the server sent one
        const dispo = res.headers['content-disposition'] || '';
        const match = /filename="?([^"]+)"?/i.exec(dispo);
        const filename = match?.[1] || `fiberhome-products-${Date.now()}.csv`;

        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        return { filename };
    },

    bulkPriceUpdate: async (payload) => {
        const { data } = await api.post('/products/bulk-price-update', payload);
        return data.data;   // { updated, failed, items }
    },
};